import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { NgForm }   from '@angular/forms';
//import "rxjs/Rx";

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  constructor(private http: HttpClient) { }

  private profileUrl = environment.apiUrl + 'api/';
  currentUser        = JSON.parse(localStorage.getItem('currentUser') || '{}');
  public user_id     = this.currentUser.userDetails.id;
  public member_id   = this.currentUser.userDetails.member_id;
  public role_id     = this.currentUser.userDetails.role_id;
  public image_path  = "https://www.storage.anudip.org/home/storage/";



  public getAllMenues(userDetails:any) {
    if(userDetails.member.type == 'staff') {
      var idnumber = userDetails.user_id;
    } else {
      var idnumber = userDetails.enrollment_id;
    }
    return this.http.get(this.profileUrl+'get-menus?role_id='+userDetails.role_id+'&firstname='+userDetails.member.first_name+'&lastname='+userDetails.member.last_name+'&email='+userDetails.email+'&username='+userDetails.email+'&idnumber='+idnumber);
  }
}
